<template>
	<div @click="$emit('click', $event)" :style="wrapperStyle">
		<pdf-embed v-if="item.url" :url="item.url" :file-name="item.fileName" :class="`agreement-pdf align-${item.alignment || 'center'}`" :style="`width: ${item.scale || 100}%`"></pdf-embed>
		<div v-else><v-icon class="material-symbols-rounded" size="100">picture_as_pdf</v-icon></div>
	</div>
</template>

<script>
	// Agreement PdfBlock: the form PdfEmbed (chrome-free pages, live links) with
	// agreement spacing — pt/pb/pl/pr like ImageBlock, scale as width-%.
	import ResponsiveMixin from './ResponsiveMixin';
	import PdfEmbed from '@/modules/forms/v2/schema/PdfEmbed';

	export default {
		name: 'PdfBlock',

		props: ['item', 'isMobile', 'pageWidth'],

		mixins: [ResponsiveMixin],

		components: { PdfEmbed },

		computed: {
			wrapperStyle: function () {
				return `width: 100%; box-sizing: border-box; padding: ${this.item.pt || 0}px ${this.padding(this.item.pr || 0)}px ${this.item.pb || 0}px ${this.padding(this.item.pl || 0)}px;`;
			},
		},
	};
</script>

<style scoped lang="scss">
	.agreement-pdf {
		max-width: 100%;
		margin: 0 auto;

		&.align-left { margin-left: 0; }
		&.align-right { margin-right: 0; }
	}
</style>
